import React, { useState, useCallback, MouseEvent } from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { useGrupoPizza } from '../../../../../../../hooks/grupoPizza';

import {
  AccordionTitleWrapper,
  AccordionActionsWrapper,
} from '../../../drawer_styles';
import { MenuOptionButton } from '../../../../styles';
import { Backdrop, Fade, Modal } from '@material-ui/core';
import { ModalWrapper } from '../../../../../../../components/Header/styles';
import { RiCloseLine } from 'react-icons/ri';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '48px',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
);

interface SummaryProps {
  title: string;
  isObrigatorio: boolean;
  index: number;
}

const ITEM_HEIGHT = 48;

const Summary: React.FC<SummaryProps> = ({ title, isObrigatorio, index }) => {
  const {
    deleteComplemento,
    toggleComplementosDrawer,
    changeSelectedComplementoIndex,
  } = useGrupoPizza();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [modalIsOpened, setModalIsOpened] = useState(false);

  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleClick = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleEditComplemento = useCallback(() => {
    changeSelectedComplementoIndex(index);
    toggleComplementosDrawer();
  }, [toggleComplementosDrawer]);

  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        className={classes.root}
      >
        <Grid container justify="space-between" alignItems="center">
          <Grid item lg={3} md={3} xs={4}>
            <AccordionTitleWrapper>
              <h4>{title}</h4>
            </AccordionTitleWrapper>
          </Grid>

          <Grid item lg={3} md={3} xs={4}>
            <AccordionActionsWrapper>
              <span>{isObrigatorio ? 'Obrigatório' : 'Opcional'}</span>

              <div
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
              >
                <IconButton
                  aria-label="more"
                  aria-controls="options-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="options-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: '20ch',
                    },
                  }}
                >
                  <MenuItem onClick={handleClose}>
                    <MenuOptionButton
                      type="button"
                      onClick={handleEditComplemento}
                    >
                      Editar
                    </MenuOptionButton>
                  </MenuItem>

                  <MenuItem onClick={handleClose}>
                    <MenuOptionButton
                      type="button"
                      onClick={() => setModalIsOpened(true)}
                    >
                      Excluir
                    </MenuOptionButton>
                  </MenuItem>
                </Menu>
              </div>
            </AccordionActionsWrapper>
          </Grid>
        </Grid>
      </AccordionSummary>
      <Modal
        className={classes.modal}
        open={modalIsOpened}
        onClose={() => setModalIsOpened(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalIsOpened}>
          <ModalWrapper>
            <div className="header">
              <h1>Atenção</h1>

              <button type="button" onClick={() => setModalIsOpened(false)}>
                <RiCloseLine size={30} />
              </button>
            </div>

            <div className="description">
              <span>Deseja excluir o complemento {title}?</span>
            </div>

            <div className="btnActions">
              <button
                type="button"
                className="confirm"
                onClick={() => deleteComplemento(index)}
              >
                Confirmar
              </button>

              <button
                type="button"
                className="cancel"
                onClick={() =>  setModalIsOpened(false)}
              >
                Cancelar
              </button>
            </div>
          </ModalWrapper>
        </Fade>
      </Modal>
    </>
  );
};

export default Summary;
